// src/components/PrivateRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * PrivateRoute component to protect routes that require authentication.
 *
 * @param {Object} element - The element to render if authenticated.
 * @param {Object} rest - Any additional props passed to the Route.
 */
export default function PrivateRoute({ element, ...rest }) {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    // If not authenticated, redirect to login page and preserve the location
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // If authenticated, render the requested element
  return element;
}
